import type { ReactNode } from 'react';

import type { MoneyFieldConfig } from '../../config';
import type { SectionKey } from '../../lease-details.types';
import { LeaseMoneyInput } from '../../inputs/lease-money-input';
import { useFieldEventContextBuilder } from '../use-field-event-context';

export type MoneyFieldProps = {
  path: string;
  field: MoneyFieldConfig;
  sectionKey: SectionKey;
  arrayIndex?: number;
  required: boolean;
  disabled: boolean;
  label: ReactNode;
  helperText: ReactNode;
};

export const MoneyField = ({
  path,
  field,
  sectionKey,
  arrayIndex,
  required,
  disabled,
  label,
  helperText,
}: MoneyFieldProps) => {
  const buildContext = useFieldEventContextBuilder<string>(path, sectionKey, arrayIndex);
  const handleBlur = (value: string | undefined) => {
    // See `TextField` — coerce to '' so the callback honors its
    // `FieldEventContext<string>` contract.
    field.events?.onBlur?.(buildContext(value ?? ''));
  };
  const handleChange = (value: string) => {
    field.events?.onChange?.(buildContext(value));
  };

  return (
    <LeaseMoneyInput
      name={path}
      title={typeof label === 'string' ? label : ''}
      placeholder={field.placeholder}
      helperText={helperText}
      required={required}
      disabled={disabled}
      fixedDecimalScale={field.fixedDecimalScale}
      onBlurValue={field.events?.onBlur ? handleBlur : undefined}
      onChangeValue={field.events?.onChange ? handleChange : undefined}
    />
  );
};
